export default class CollectionBanner extends HTMLElement {
  constructor() {
    super();

    this.logo = this.querySelector(".collection-banner__logo");
    this.imgLeft = this.querySelector(".collection-banner__img-left");
    this.imgRight = this.querySelector(".collection-banner__img-right");
  }

  connectedCallback() {
    this.imageAnimation();
  }
  imageAnimation() {
    if (this.logo) {
        this.logo.style.opacity = '1';
        this.logo.style.setProperty('--tw-translate-y', '0');
    }

    if (this.imgLeft) {
        this.imgLeft.style.opacity = '1';
        this.imgLeft.style.setProperty('--tw-translate-x', '0');
    }

    if (this.imgRight) {
        this.imgRight.style.opacity = '1';
        this.imgRight.style.setProperty('--tw-translate-x', '0');
    }
  }

}

customElements.define("collection-banner", CollectionBanner);